import {Routes} from '@angular/router';
import {authGuard} from "./auth/auth.guard";

export const appRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('./features/landing-page/landingpagecomponent').then(m => m.LandingPageComponent)
    },
    {
        path: 'instagram',
        loadComponent: () =>
            import('./features/instagram-landing/instagram-landing.component').then(m => m.InstagramLandingComponent)
    },
    {
        path: 'registration',
        loadComponent: () =>
            import('./features/provider-register/salon-register.component').then(m => m.SalonRegisterComponent)
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./features/auth/login/logincomponent').then(m => m.LoginComponent)
    },
    {
        path: 'cancel',
        loadComponent: () =>
            import('./features/booking/cancel/cancel-appointment.component').then(m => m.CancelAppointmentComponent)
    },
    {
        path: 'salons',
        loadComponent: () =>
            import('./features/salon/salon-list/salonlistcomponent').then(m => m.Salonlistcomponent)
    },
    {
        path: 'salons/category/:category',
        loadComponent: () =>
            import('./features/salon/salon-list/salonlistcomponent').then(m => m.Salonlistcomponent)
    },
    {
        path: 'admin/dashboard',
        loadComponent: () =>
            import('./features/admin/provider-dashboard/provider-dashboard.component').then(m => m.ProviderDashboardComponent),
        canActivate: [authGuard],
        data: { roles: ['PROVIDER'] }
    },
    {
        path: 'admin/approvals',
        loadComponent: () =>
            import('./features/admin/provider-approvals/provider-approvals.component').then(m => m.ProviderApprovalsComponent),
        canActivate: [authGuard],
        data: { roles: ['ADMIN'] }
    },
    {
        path: 'admin/working-hours',
        loadComponent: () =>
            import('./features/admin/working-hours/working-hours.component').then(m => m.WorkingHoursComponent),
        canActivate: [authGuard],
        data: { roles: ['PROVIDER'] }
    },
    {
        path: 'admin/services',
        loadComponent: () =>
            import('./features/admin/salon-settings/services-setup.component')
                .then(m => m.ServicesSetupComponent),
        canActivate: [authGuard],
        data: { roles: ['PROVIDER'] }
    },

    {
        path: 'admin/appointments',
        loadComponent: () =>
            import('./features/admin/appointments-management/appointments-management.component')
                .then(m => m.AppointmentsManagementComponent),
        canActivate: [authGuard],
        data: { roles: ['PROVIDER'] }
    },
    {
        path: 'salons/details/:id',
        loadComponent: () =>
            import('./features/salon/salon-detail/salondetailcomponent').then(m => m.SalonDetailsComponent)
    },

    {
        path: '**',
        redirectTo: ''
    }
];
